import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dom = $(el);
    const videoDom = dom.find('video');
    const video = videoDom.get(0);

    let isLoaded = false;
    let isPlaying = false;

    const onLoadStart = () => {

    };

    const onTimeUpdate = () => {
        if (!video || video.currentTime < 0.001) {
            return;
        }
        removeVideoEventListeners();

        TweenLite.set(video, { opacity: 0 });
        video.removeAttribute('hidden');
        TweenLite.to(video, 0.2, { opacity: 1, ease: Sine.easeOut });
    };

    const addVideoEventListeners = () => {
        if (!video) {
            return;
        }
        video.addEventListener('timeupdate', onTimeUpdate);
        video.addEventListener('loadstart', onLoadStart);
        video.addEventListener('loadedmetadata', onLoadStart);
        video.addEventListener('loadeddata', onLoadStart);
        video.addEventListener('canplay', onLoadStart);
    };

    const removeVideoEventListeners = () => {
        if (!video) {
            return;
        }
        video.removeEventListener('timeupdate', onTimeUpdate);
        video.removeEventListener('loadstart', onLoadStart);
        video.removeEventListener('loadedmetadata', onLoadStart);
        video.removeEventListener('loadeddata', onLoadStart);
        video.removeEventListener('canplay', onLoadStart);
    };

    const playAndCatch = () => {
        addVideoEventListeners();
        video.src = videoDom.data('src');
        video.muted = true;
        isLoaded = true;

        const promise = video.play();

        if (promise !== undefined) {
            promise.then(() => {
                isPlaying = true;
            }).catch(e => {
                removeVideoEventListeners();
            });
        }
    }

    const play = () => {
        if (isLoaded) {
            if (!isPlaying) {
                video.play();
                isPlaying = true;
            }
        } else {
            playAndCatch();
        }
    };

    const pause = () => {
        if (isPlaying) {
            video.pause();
            isPlaying = false;
        }
    };

    const init = () => {
        if (!video.canPlayType || !video.canPlayType('video/mp4')) {
            return;
        }
        dom.on('mouseenter', play);
        dom.on('mouseleave', pause);
    };

    const destroy = () => {
        dom.off('mouseenter', play);
        dom.off('mouseleave', pause);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/PreviewVideo.js